import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { Surface, Button } from '@heroui/react';
import { useAuthStore } from '@/stores/authStore';

/**
 * Renders when JWT exchange fails (expired token, bad signature, etc).
 * Built on HeroUI primitives (Surface + Button) with native tokens so it
 * matches the rest of the product instead of reading like a stock error
 * page.
 */
export function LoginErrorPage() {
  const { t } = useTranslation();
  const error = useAuthStore((s) => s.error);
  const navigate = useNavigate();
  return (
    <div className="grid h-full place-items-center bg-surface p-8 text-center">
      <div className="flex max-w-md flex-col items-center gap-6">
        <div>
          <div className="mb-3 text-sm font-medium text-danger">{t('ui2.loginError.eyebrow')}</div>
          <h1 className="text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">
            {t('ui2.loginError.title')}
          </h1>
          <p className="mt-3 text-sm text-muted">
            {error ?? t('ui2.loginError.defaultMessage')}
          </p>
        </div>

        <Surface
          variant="secondary"
          className="w-full rounded-xl border border-separator px-6 py-5 text-sm text-muted"
        >
          <Trans
            i18nKey="ui2.loginError.returnHint"
            components={{
              1: (
                <a
                  href="https://cispracs.ru"
                  className="text-accent underline decoration-accent/40 underline-offset-2 hover:decoration-accent"
                />
              ),
            }}
          />
        </Surface>

        <Button variant="secondary" onPress={() => navigate('/')}>
          {t('ui2.loginError.home')}
        </Button>
      </div>
    </div>
  );
}
